export default __webpack_public_path__ + "static/media/star.ae879a86.svg";